import { Component, WritableSignal, effect, inject, input, signal } from '@angular/core';
import { Router } from '@angular/router';

import { map } from 'rxjs';

import { InformationPopulationService } from '../../services/information-population.service';
import { RaceService } from '../../services/race.service';

import { InformationPopulation } from '../../interfaces/information-population';
import { StarSystem } from "../../interfaces/star-system";
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'star-system-display-admin',
  templateUrl: './star-system-display-admin.component.html',
  standalone: false
})
export class StarSystemDisplayAdminComponent {
  informationPopulationService = inject(InformationPopulationService);
  raceService = inject(RaceService);
  router = inject(Router);

  displayMoons = input<boolean>(false);
  starSystem = input.required<StarSystem>();

  populations: WritableSignal<{ [key: string]: { [key: string]: InformationPopulation; }; } | undefined> = signal({});

  raceLookup = new Map();

  constructor () {
    effect(() => {
      if (!this.starSystem()) {
        return;
      }
      this.informationPopulationService.getInformationPopulationForStarSystemId(this.starSystem()._id).pipe(
        map(ips => {
          let initHash: { [key: string]: { [key: string]: InformationPopulation; }; } = {};
          let popHash = ips.reduce((hash, ip) => {
            let raceId = ip.populationForRaceId;
            let pops: { [key: string]: InformationPopulation; } = hash[ip.planetId] || {};
            pops[ip.populationForRaceId] = ip;
            hash[ip.planetId] = pops;
            if (!this.raceLookup.has(raceId)) {
              this.raceService.getRaceForId$(raceId).subscribe(
                race => this.raceLookup.set(raceId, race)
              );
            }
            return hash;
          }, initHash);
          return popHash;
        }),
      ).subscribe(popHash => {
        this.populations.set(popHash);
      });
    });
  };

  openStarSystem(campaignId: string, starSystemId: string) {
    return this.router.navigate(['/campaign', campaignId, 'starSystemDisplay', starSystemId]);
  };
};
